import { render } from "./PCAsignacionDatosOrigen.vue?vue&type=template&id=22de0c88"
import script from "./PCAsignacionDatosOrigen.vue?vue&type=script&lang=js"
export * from "./PCAsignacionDatosOrigen.vue?vue&type=script&lang=js"

import "./PCAsignacionDatosOrigen.vue?vue&type=style&index=0&id=22de0c88&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__